import type { Component } from 'svelte';
import type { RouteName } from './router.js';

export type RouteModule = { default: Component };

export type RouteLoader = () => Promise<RouteModule>;

export const routeLoaders: Record<RouteName, RouteLoader> = {
  home: () => import('../pages/HomePage.svelte'),
  'new-game': () => import('../pages/NewGamePage.svelte'),
  game: () => import('../pages/GamePage.svelte'),
  'game-summary': () => import('../pages/GameSummaryPage.svelte'),
  'saved-games': () => import('../pages/SavedGamesPage.svelte'),
  replay: () => import('../pages/ReplayPage.svelte'),
  'portable-replay': () => import('../pages/ReplayPage.svelte'),
  stats: () => import('../pages/StatsPage.svelte'),
  'how-to-play': () => import('../pages/HowToPlayPage.svelte'),
  settings: () => import('../pages/SettingsPage.svelte'),
  privacy: () => import('../pages/PrivacyPage.svelte'),
  'expert-inbox': () => import('../pages/ExpertInboxPage.svelte'),
  gallery: () => import('../pages/GalleryPage.svelte'),
  'not-found': () => import('../pages/HomePage.svelte'),
};

export async function loadRouteComponent(name: RouteName): Promise<Component> {
  const module = await routeLoaders[name]();
  return module.default;
}
